/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum SupportedCarriers {
  NONE = "NONE",
  DHL = "DHL",
  DHL_EXPRESS = "DHL_EXPRESS",
}

export enum Tier {
  None = "None",
  Insider = "Insider",
  Icon = "Icon",
  Elite = "Elite",
}

export enum TransactionType {
  Earn = "Earn",
  Return = "Return",
  Expire = "Expire",
  Grant = "Grant",
}

export enum RegionCode {
  GLOBAL = "GLOBAL",
  EAP = "EAP",
  EU = "EU",
  AME = "AME",
}

export enum CustomerConsentType {
  Newsletter = "Newsletter",
  MyECCO = "MyECCO",
  TermsAndConditions = "TermsAndConditions",
  PrivacyPolicy = "PrivacyPolicy",
  Loyalty = "Loyalty",
  Personalisation = "Personalisation",
  NewsletterSMS = "NewsletterSMS",
  Unknown = "Unknown",
}

export enum SocialProvider {
  Google = "Google",
  Facebook = "Facebook",
  Apple = "Apple",
  Naver = "Naver",
  Kakao = "Kakao",
  Line = "Line",
}

export enum LineItemStatus {
  Unavailable = "Unavailable",
  AlreadyInCart = "AlreadyInCart",
  PartiallyAdded = "PartiallyAdded",
  FullyAdded = "FullyAdded",
}

export enum Status {
  Active = "Active",
  Expired = "Expired",
  Canceled = "Canceled",
  Notified = "Notified",
}

export enum UseCaseResultErrorCode {
  Unknown = "Unknown",
  Error = "Error",
  SessionError = "SessionError",
  CommerceToolsTokenError = "CommerceToolsTokenError",
  Validation = "Validation",
  MissingSessionId = "MissingSessionId",
  MissingUCID = "MissingUCID",
  HeaderOrPostDataInvalid = "HeaderOrPostDataInvalid",
  UncaughtEndpointException = "UncaughtEndpointException",
  BarcodeGenerationError = "BarcodeGenerationError",
  ServiceMaintenance = "ServiceMaintenance",
  CustomerNotFound = "CustomerNotFound",
  CustomerWithValidConsentNotFound = "CustomerWithValidConsentNotFound",
  CustomerNotLoggedOut = "CustomerNotLoggedOut",
  CustomerLogoutFailure = "CustomerLogoutFailure",
  CustomerGetFailure = "CustomerGetFailure",
  CustomerCreateFailure = "CustomerCreateFailure",
  CustomerDeleteFailure = "CustomerDeleteFailure",
  CustomerUpdateFailure = "CustomerUpdateFailure",
  CustomerExists = "CustomerExists",
  CustomerLoginFailure = "CustomerLoginFailure",
  AuthenticationFailure = "AuthenticationFailure",
  SocialIdentityFailure = "SocialIdentityFailure",
  CustomerContactFormError = "CustomerContactFormError",
  PasswordChangeError = "PasswordChangeError",
  PasswordResetError = "PasswordResetError",
  PasswordResetCompletionError = "PasswordResetCompletionError",
  PasswordResetTokenExpired = "PasswordResetTokenExpired",
  PasswordInvalidError = "PasswordInvalidError",
  PasswordEncryptError = "PasswordEncryptError",
  PasswordDecryptError = "PasswordDecryptError",
  ExistingPasswordNotValid = "ExistingPasswordNotValid",
  ConsentOptInFailure = "ConsentOptInFailure",
  ConsentOptOutFailure = "ConsentOptOutFailure",
  ConsentNewsletterOptInFailure = "ConsentNewsletterOptInFailure",
  ConsentNewsletterOptOutFailure = "ConsentNewsletterOptOutFailure",
  CartCreationFailure = "CartCreationFailure",
  CartRetrievalFailure = "CartRetrievalFailure",
  CartAddLineFailure = "CartAddLineFailure",
  CartRemoveLineFailure = "CartRemoveLineFailure",
  CartLineQuantityFailure = "CartLineQuantityFailure",
  CartAddCouponFailure = "CartAddCouponFailure",
  CartRemoveCouponFailure = "CartRemoveCouponFailure",
  CartValidationFailure = "CartValidationFailure",
  CartValidation = "CartValidation",
  AddressInvalid = "AddressInvalid",
  AddressObjectMissing = "AddressObjectMissing",
  StreetNameMissing = "StreetNameMissing",
  PostCodeMissing = "PostCodeMissing",
  NameAndLastNameOrCompanyNameMissing = "NameAndLastNameOrCompanyNameMissing",
  PaymentCreateFailure = "PaymentCreateFailure",
  PaymentCaptureFailure = "PaymentCaptureFailure",
  PaymentMethodsFetchError = "PaymentMethodsFetchError",
  InitiatePaymentError = "InitiatePaymentError",
  SubmitPaymentError = "SubmitPaymentError",
  NotificationPaymentError = "NotificationPaymentError",
  ReversePaymentError = "ReversePaymentError",
  OrderGeneralFailure = "OrderGeneralFailure",
  OrderDraftCreationFailure = "OrderDraftCreationFailure",
  OrderDraftFetchFailure = "OrderDraftFetchFailure",
  OrderNumberCreationFailure = "OrderNumberCreationFailure",
  OrderHistoryValidationFailure = "OrderHistoryValidationFailure",
  WishlistNotFound = "WishlistNotFound",
  WishlistVersionMismatch = "WishlistVersionMismatch",
  WishlistItemNotFound = "WishlistItemNotFound",
  AccountWithSameEmailAlreadyExists = "AccountWithSameEmailAlreadyExists",
  PendingRegistrationNotFound = "PendingRegistrationNotFound",
  PendingRegistrationUpdateFailure = "PendingRegistrationUpdateFailure",
  RateLimitExceeded = "RateLimitExceeded",
  InvalidLoyaltyTransactions = "InvalidLoyaltyTransactions",
  BackInStockSubscriptionExists = "BackInStockSubscriptionExists",
  BackInStockSubscriptionNotFound = "BackInStockSubscriptionNotFound",
  LoyaltyTierRulesNotFound = "LoyaltyTierRulesNotFound",
  BackInStockError = "BackInStockError",
  InStoreSignUpError = "InStoreSignUpError",
  InStoreSignUpWasCompleted = "InStoreSignUpWasCompleted",
  PendingRegistrationExpired = "PendingRegistrationExpired",
  PendingRegistrationExists = "PendingRegistrationExists",
  SendEmailError = "SendEmailError",
  AbandonedCartError = "AbandonedCartError",
}

export interface CustomerResponse {
  /** Unique id of the user */
  ucid: string;
  /**
   * First (given) name. If set, CompanyName should be empty
   * @minLength 0
   * @maxLength 255
   */
  firstName?: string | null;
  /**
   * Last name
   * @minLength 0
   * @maxLength 255
   */
  lastName?: string | null;
  /** Furigana (Given Name) */
  phoneticFirstName?: string | null;
  /** Furigana (Last Name) */
  phoneticLastName?: string | null;
  /** Name of the company. If set, first and last name plus the phonetic names should be empty or null */
  companyName?: string | null;
  /** Vat or tax number (depending on the market) */
  vatOrTaxNumber?: string | null;
  /** MasterDataId is an identifier in MDM */
  masterDataId?: string | null;
  /**
   * @minLength 3
   * @maxLength 320
   */
  email: string;
  /**
   * Email address that will used for sending newsletter emails (it will only be set and valid if consent for newsletters has been added)
   * @minLength 3
   * @maxLength 320
   */
  newsletterEmail?: string | null;
  phoneCountryCode?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  phoneNumber?: string | null;
  /** Male, Female, Other */
  gender?: string | null;
  /** Optionally locale ([xx]-[YY]) where [xx] is the ISO language code and [YY] is the ISO country code */
  preferredLocale?: string | null;
  /**
   * Optionally shoesize. The physical interpretation of this size depends on the market
   * @format decimal
   */
  shoeSize?: number | null;
  /** Optionally id of the store where the customer account were created */
  signupStoreId?: string | null;
  /** Optionally source that reflects the system that created the account (for instance 'web') */
  signupSource?: string | null;
  /** Optionally id of the store where the customer signed up for (loyalty) membership */
  loyaltySignupStoreId?: string | null;
  /**
   * Depending on the market various parts of the birth day is to be ignored
   * @format date
   */
  dateOfBirth?: string | null;
  /** language and country (for instance en-US or da-DK) */
  locale?: string | null;
  /** 2 character ISO code */
  countryCode?: string | null;
  /** 2 character ISO code */
  language?: string | null;
  /** Id references to the active consents that has been given by the customer. Newsletter (0), MyECCO (1), TermsAndConditions (2), PrivacyPolicy (3), Loyalty (4), Personalisation (5) */
  activeConsentTypes?: string[];
  addresses?: CustomerAddressResponse[];
  /** Loyalty information will only be returned for markets where loyalty is enabled in Headless.  */
  loyalty?: CustomerLoyaltyResponse | null;
  /** @format date-time */
  accountCreatedUtc: string;
  /** @format date-time */
  accountEditedUtc?: string | null;
}

export interface CustomerAddressResponse {
  id: string;
  /**
   * General, Shipping, Billing
   * @pattern ^(General|Shipping|Billing)$
   */
  addressType: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  fullName?: string | null;
  /**
   * Furigana (Given Name)
   * @maxLength 255
   */
  phoneticFirstName?: string | null;
  /**
   * Furigana (Last Name)
   * @maxLength 255
   */
  phoneticLastName?: string | null;
  country?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  street?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  postalCode?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  city?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  region?: string | null;
  /**
   * State and Region will be the same as the underlying datamodels use the same field for both region and state ('region').
   * @minLength 1
   * @maxLength 255
   */
  state?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  landmark?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  district?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  phone?: string | null;
  isDefault?: boolean;
  /**
   * @minLength 1
   * @maxLength 255
   */
  additionalAddressInfo?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  email?: string | null;
}

export interface CustomerLoyaltyResponse {
  /** Internal id of the card in the MDM system */
  id?: string;
  /** The card number that the customer is shown (this is also the number that should be used for the barcode) */
  cardNumber?: string;
  /**
   * The points that the customer has
   * @format int32
   */
  pointBalance?: number;
  /** The current tier of the customer.  */
  tier?: string;
}

export type EndpointFailureResponse = BaseUseCaseResult & {
  detail?: string | null;
};

export interface BaseUseCaseResult {
  success?: boolean;
  message?: string | null;
  errorCode?: UseCaseResultErrorCode | null;
  /** @format int32 */
  subSystemHttpCode?: number | null;
  subSystemResponse?: string | null;
  subSystem?: string | null;
}

export type NewsLetterOptInRequest = ConsentBaseOptInRequest & {
  /**
   * @minLength 3
   * @maxLength 320
   */
  newsletterEmail: string;
  privacyContentfulId?: string | null;
  firstName?: string | null;
  /**
   * @minLength 2
   * @maxLength 255
   */
  phoneCountryCode?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  phoneNumber?: string | null;
};

export interface ConsentBaseOptInRequest {
  source?: string | null;
  /** The id in contenful that refers to the content copy that the customer has agreed to. */
  contentfulId: string;
}

export interface Subscription {
  /** @format int32 */
  subscriptionId?: number;
  sku?: string;
  skuUrl?: string;
  userKey?: string;
  status?: Status;
  /** @format date-time */
  createdUtc?: string;
  /** @format date-time */
  expiresUtc?: string;
  /** @format date-time */
  canceledUtc?: string | null;
  /** @format date-time */
  notifiedUtc?: string | null;
}

export interface ErrorResponse {
  message?: string;
  errorCode?: UseCaseResultErrorCode;
  metadata?: Record<string, any> | null;
  success?: boolean;
}

export interface AddSubscriptionRequest {
  sku?: string;
  skuUrl?: string;
  consents?: Consents;
  guestEmail?: string | null;
}

export interface Consents {
  privacyPolicyConsentContentfulId?: string;
}

export interface CreateSubscriptionRequest {
  sku?: string;
  skuUrl?: string;
  backInStockConsents?: BackInStockConsents;
  guestEmail?: string | null;
}

export interface BackInStockConsents {
  privacyPolicyConsentContentfulId?: string;
  backInStockConsentContentfulId?: string | null;
}

export interface ValidateCartResponse {
  cartId: string;
  isCartValid?: boolean;
  errors?: CartValidationErrorResponse[];
  warnings?: string[];
}

export interface CartValidationErrorResponse {
  errorCode?: string;
  message?: string;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface RebuildCartResponse {
  cartId?: string;
  lineItems?: LineItemResult[];
}

export interface LineItemResult {
  sku?: string;
  size?: string;
  /** @format int32 */
  quantityRequested?: number;
  /** @format int32 */
  quantityAdded?: number;
  status?: LineItemStatus;
}

export interface RebuildCartRequest {
  lineItems?: string;
  currency?: string;
}

export interface CustomerContactFormRequest {
  firstName: string;
  lastName: string;
  email: string;
  /** The country code (for instance +44) */
  phoneCountryCode?: string;
  phone?: string;
  /** Optionally. The order number that the request may be about */
  orderNumber?: string | null;
  /** The topic 'My Question' for the contact */
  topic: string;
  /** The question to be asked */
  comment: string;
  privacyPolicyConsentContentfulId: string;
  /** Reference to the contentful text that covers terms and conditions. Note that if the legal text covers multiple consents, the id can be reused */
  termsAndConditionConsentContentfulId: string;
  /** Optional reference to the contentful text that covers newsletters. Note that if the legal text covers multiple consents, the id can be reused */
  newsletterConsentContentfulId?: string | null;
}

export interface CustomerLoginResponse {
  /** Customer id */
  ucid: string;
  /** Optional. Will contain token information for CT communication usage */
  authorizedCtToken?: SessionTokenResponse | null;
}

export interface SessionTokenResponse {
  id?: string;
  /** @format int32 */
  expiresInSeconds?: number;
  refreshToken?: string;
  scope?: string;
  source?: string;
}

export interface CustomerLoginRequest {
  /**
   * @minLength 3
   * @maxLength 320
   */
  email: string;
  password: string;
}

export interface CustomerSocialLoginRequest {
  /**
   * @minLength 3
   * @maxLength 320
   */
  socialEmail: string;
  socialProvider: SocialProvider;
  /**
   * @minLength 2
   * @maxLength 255
   */
  socialProviderAccountId: string;
}

export interface CustomerLogoutResponse {
  customerId: string;
  success: boolean;
}

export type CreateCustomerRequest = ModifyCustomerRequest & {
  /**
   * @minLength 3
   * @maxLength 320
   */
  email: string;
  password: string;
  /** Reference to the contentful text that covers privacy policy. Note that if the legal text covers multiple consents, the id can be reused */
  privacyPolicyConsentContentfulId: string;
  /** Reference to the contentful text that covers terms and conditions. Note that if the legal text covers multiple consents, the id can be reused */
  termsAndConditionConsentContentfulId: string;
  /** Optional reference to the contentful text that covers loyalty. Note that if the legal text covers multiple consents, the id can be reused */
  loyaltyConsentContentfulId?: string | null;
  /** Optional reference to the contentful text that covers newsletters. Note that if the legal text covers multiple consents, the id can be reused */
  newsletterConsentContentfulId?: string | null;
  source?: string | null;
  storeId?: string | null;
};

export interface ModifyCustomerRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  firstName?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  lastName?: string | null;
  /** Furigana (Given Name) */
  phoneticFirstName?: string | null;
  /** Furigana (Surname) */
  phoneticLastName?: string | null;
  /** Name of the company. If set, first and last name plus the phonetic names should be empty or null */
  companyName?: string | null;
  /** Vat or tax number (depending on the market) */
  vatOrTaxNumber?: string | null;
  phoneCountryCode?: string | null;
  /** To clear / remove the phone number, an empty string must be supplied */
  phoneNumber?: string | null;
  /**
   * Male, Female, Prefer not to say, Other (In the response 'Other' will be returned as 'Prefer not to say')
   * @pattern ^(Male|Female|Other|Prefer not to say)$
   */
  gender?: string | null;
  /** 2 character ISO code (lowercase) */
  preferredLanguage?: string | null;
  /**
   * @format decimal
   * @pattern ^\d{1,2}(\.\d{1,2})?$
   */
  shoeSize?: number | null;
  /** @format int32 */
  yearOfBirth?: number | null;
  /** @format int32 */
  monthOfBirth?: number | null;
  /** @format int32 */
  dayOfBirth?: number | null;
}

export type UpdateCustomerRequest = ModifyCustomerRequest & object;

export interface CustomerAddressRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  fullName?: string | null;
  /** @maxLength 255 */
  phoneticFirstName?: string | null;
  /** @maxLength 255 */
  phoneticLastName?: string | null;
  /**
   * General, Shipping, Billing
   * @pattern ^(General|Shipping|Billing)$
   */
  addressTypeName?: string;
  country?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  street?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  postalCode?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  city?: string | null;
  /**
   * Aka "State" in some markets
   * @minLength 1
   * @maxLength 255
   */
  region?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  landmark?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  district?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  phone?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  additionalAddressInfo?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  email?: string | null;
  /** Sets whether or not this address is the default. As only one address can be default, adding or editing and address with 'IsDefault' = true will remove the default from all other addresses (if any) */
  isDefault?: boolean;
}

export type CustomerEditAddressRequest = CustomerAddressRequest & {
  id: string;
};

export type ConsentOptInRequest = ConsentBaseOptInRequest & {
  consentType: CustomerConsentType;
};

export interface ChangePasswordRequest {
  /** Existing password. It's required by SFAPI */
  existingPassword: string;
  newPassword: string;
}

export interface CustomerInitiatePasswordResponse {
  passwordResetUrl: string;
  passwordResetToken: string;
}

export interface InitiatePasswordChangeRequest {
  email: string;
  /** @default "https://localhost:3000/reset-password?f=1234" */
  resetPasswordUrl: string;
}

export interface CompletePasswordChangeRequest {
  passwordResetToken: string;
  /** See Heap/PasswordRequirements for the password complexity requirements */
  newPassword: string;
}

export interface GetDeliveryDatesResponse {
  dates?: string[];
  cartId?: string;
}

export interface DeliveryEstimateResponse {
  id?: string;
  sku?: string;
  destination?: DeliveryEstimateDestinationResponse;
  status?: string;
  estimate?: DeliveryEstimateDatesResponse;
  /** @format date-time */
  expiresAt?: string;
}

export interface DeliveryEstimateDestinationResponse {
  scopeType?: string;
  country?: string;
  zipcode?: string | null;
}

export interface DeliveryEstimateDatesResponse {
  /** @format date */
  deliveryDate?: string | null;
  /** @format date */
  earliestDeliveryDate?: string | null;
  /** @format date */
  latestDeliveryDate?: string | null;
}

export interface GetPingResponse {
  version?: string;
  language?: string;
  country?: string;
  region?: string;
  isCustomerLoggedIn?: boolean;
  /** @format date-time */
  serverTimeUtc?: string;
}

export interface ErrorCodeResponse {
  /** @format int32 */
  errorCode: number;
  errorCodeString: string;
}

export interface MarketSettingsResponse {
  isMarketWithLoyalty?: boolean;
  region?: RegionCode;
  /** Country / Market (In upper-case) */
  country?: string;
  /** In lower-case */
  language?: string;
  phonePrefix?: string;
  customerProfileSettings?: CustomerProfileSettingsResponse;
  saleSystemSettings?: SalesSystemResponse;
  shippingSettings?: ShippingSettingsResponse;
  orderHistorySettings?: OrderHistoryMarketResponse;
  warehouseHolidays?: WarehouseHolidayMarketSettings;
  apis?: string[];
}

export interface CustomerProfileSettingsResponse {
  /** @format int32 */
  passwordLength?: number;
  requireUppercaseCharacter?: boolean;
  requireLowercaseCharacter?: boolean;
  requireNumber?: boolean;
  requireSpecialCharacter?: boolean;
  /** @format int32 */
  resetPasswordExpirationMinutes?: number;
  enforceLegalConsentValidation?: boolean;
}

export interface SalesSystemResponse {
  /** The name of the sales system (e.g., 'US-MobileApp', 'US-ECOMMERCE'). The value is market specific */
  name: string;
  /**
   * The max number of order lines that is allowed in a basket
   * @format int32
   */
  maxBasketLines?: number;
  /**
   * The max number of items, across order lines that is allowed
   * @format int32
   */
  maxBasketQuantity?: number;
  /**
   * The max number of items, across order lines that is allowed
   * @format int32
   */
  maxBasketTotalPrice?: number;
}

export interface ShippingSettingsResponse {
  unitedBroker?: ShippingUnitedBrokerResponse | null;
}

export interface ShippingUnitedBrokerResponse {
  carrier?: string | null;
}

export interface OrderHistoryMarketResponse {
  source?: string;
  zigZagMarket?: boolean;
  zigZagBaseUrl?: string;
  /** @format int32 */
  zigZagShowLinkForDays?: number;
}

export interface WarehouseHolidayMarketSettings {
  dates?: string[];
}

export interface InitiateSignUpRequest {
  firstName?: string;
  lastName?: string;
  storeId?: string;
  email?: string;
  password?: string;
  privacyPolicyConsentContentfulId?: string;
  termsAndConditionConsentContentfulId?: string;
  loyaltyConsentContentfulId?: string;
  newsletterConsentContentfulId?: string | null;
  /** @format guid */
  emailVerificationId?: string;
  localizedEmailVerificationLink?: string;
  phoneticFirstName?: string | null;
  phoneticLastName?: string | null;
  phoneCountryCode?: string | null;
  phoneNumber?: string | null;
  gender?: string | null;
  preferredLanguage?: string | null;
  /** @format decimal */
  shoeSize?: number | null;
  /** @format int32 */
  yearOfBirth?: number | null;
  /** @format int32 */
  monthOfBirth?: number | null;
  /** @format int32 */
  dayOfBirth?: number | null;
}

export interface FinalizeSignUpResponse {
  ucid?: string;
  authorizedCtToken?: SessionTokenResponse | null;
}

export interface FinalizeSignUpRequest {
  /** @format guid */
  emailVerificationId?: string;
}

export interface CreateCartRequest {
  currency: string;
  preferredShippingMethod: string;
}

export interface ShippingValidatorResult {
  isValid?: boolean;
  code?: string;
  availabilityForItemsThatCannotBeShipped?: ProductAvailability[] | null;
}

export interface ProductAvailability {
  /** @format int64 */
  quantityWanted?: number;
  /** @format int64 */
  quantityAvailable?: number;
  sku?: string;
}

export interface GetLoyaltyHistoryResponse {
  loyaltyTransactions?: LoyaltyTransactionInfo[];
  pointsExpiration?: PointsExpiration;
  upcomingTier?: UpcomingTier | null;
}

export interface LoyaltyTransactionInfo {
  orderNumber?: string;
  transactionType?: TransactionType;
  tier?: Tier;
  /** @format int32 */
  rewardPoints?: number;
  /** @format date-time */
  transactionDate?: string;
}

export interface PointsExpiration {
  expiringTransactions?: ExpiringTransaction[];
  /** @format int32 */
  daysToExpire?: number;
  /** @format int32 */
  totalPointsToExpire?: number;
}

export interface ExpiringTransaction {
  orderNumber?: string;
  /** @format int32 */
  pointsToExpire?: number;
}

export interface UpcomingTier {
  nextTier?: Tier;
  /** @format int32 */
  pointsToNextTier?: number;
}

export interface OrderDraftResponse {
  /**
   * Order draft id. The unique id that identifies the order draft in Heap.
   * @format guid
   */
  id: string;
  /**
   * The order reference number.
   * This may be used by several order drafts if the user attempts to create multiple order drafts for the same order (for instance by clicking the "Buy now" button several times).
   */
  orderNumber: string;
  /** ISO locale information. For instance fr-FR.  */
  locale: string;
  /** Currency code (ISO 4217 format). For instance "EUR" or "USD". */
  currency: string;
  /** The unique identifier for the customer in MDM. This may be null if the user is a guest user, or if the customer has not been created in MDM yet. */
  customerId?: string | null;
  /** If true, then the order is being made by a guest user. */
  guestUser: boolean;
  /**
   * The status of the order draft. It's sent to D365 if it's "Delivered".
   * For all states see here: https://kb.ecco.com/spaces/GLOBCOM/pages/274336136/State+models
   */
  draftStatusName: string;
  /** @format decimal */
  paymentAmount: number;
  paymentProvider: string;
  paymentMethod: string;
  /** For instance "ParcelShop", "HomeDelivery" or "ClickAndCollect".  */
  orderType: string;
  /** For instance "HD", "PS" or "CC" */
  deliveryMode: string;
  /** The localized name for the delivery method */
  deliveryMethodLocalized: string;
  deliveryDate: string | null;
  deliveryTimeSlot: string | null;
  konbini?: OrderDraftKonbiniResponse | null;
  /** @format date-time */
  createdUtc: string;
  cart: CartResponse;
}

export interface OrderDraftKonbiniResponse {
  expiresAt: string;
  reference: string;
  url: string;
}

export interface CartResponse {
  cartPrice: CartPriceResponse;
  lines: CartLineResponse[];
  /** The billing address must be set before an order draft can be made. */
  billingAddress: CartAddressResponse;
  /** Shipping/Delivery address. If the address is not set when the order draft is made, billing address information is copied as the shipping address. */
  shippingAddress: CartAddressResponse;
}

export interface CartPriceResponse {
  /**
   * The number of fraction digits to show.
   * @format int32
   */
  fractionDigits: number;
  /**
   * Price including tax, shipping etc. (For markets with tax in prices, this will be the same as 'TotalPrice')
   * @format decimal
   */
  grossPrice: number;
  /**
   * Price without tax and shipping (subtotal)
   * @format decimal
   */
  netPrice: number;
  /**
   * The total amount of discount applied to the order.
   * @format decimal
   */
  totalDiscount: number;
  /**
   * Cost of shipping before discountrs
   * @format decimal
   */
  shippingInitialPrice: number;
  /** @format decimal */
  shippingDiscountPrice: number;
  /**
   * Shipping cost to be paid by the customer (incl tax)
   * @format decimal
   */
  shippingPrice: number;
  /**
   * Shipping cost excluding tax.
   * @format decimal
   */
  shippingNetPrice: number;
  /**
   * The total tax for the full order, including shipping.
   * @format decimal
   */
  tax: number;
  /**
   * The price for the items before potential discounts (shipping is not included either)
   * @format decimal
   */
  itemPriceBeforeDiscount?: number;
}

export interface CartLineResponse {
  /** @format int32 */
  lineNumber: number;
  /** Non-localized name */
  systemName: string;
  /** Name for the particular market (localized) */
  marketName?: string | null;
  /** Color by the name of the locale (or english if the localized name is not set) */
  dominantColor?: string | null;
  size?: string | null;
  /** In commercetools, this is extracted from the variant (key) */
  ean: string;
  sku: string;
  /** Used for "productKey"  */
  slug?: string | null;
  /** @format int32 */
  quantity: number;
  imageUrl?: string | null;
  /** @format decimal */
  totalGrossPrice: number;
  /** @format decimal */
  totalNetPrice: number;
  /**
   * Full price. May include tax (in markets with taxes included)
   * @format decimal
   */
  pricePerUnit: number;
  /** @format decimal */
  pricePerUnitWithDiscount: number;
  /** @format decimal */
  recommendedRetailPrice?: number | null;
  /**
   * 30-day lowest price (Omnibus). From CT custom field price_CF_PreviousLowestPrice.
   * @format decimal
   */
  omnibusPrice?: number | null;
  /**
   * Full discount applied to the line
   * @format decimal
   */
  totalDiscount: number;
  /** @format decimal */
  taxRate: number;
  /** @format decimal */
  taxAmount: number;
}

export interface CartAddressResponse {
  title?: string | null;
  salutation?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneticFirstName?: string | null;
  phoneticLastName?: string | null;
  city?: string | null;
  country?: string | null;
  state?: string | null;
  /** Street name (StreetName in CT) */
  street?: string | null;
  streetNumber?: string | null;
  /** address_CF_Landmark */
  landmark?: string | null;
  /** Zip */
  postalCode?: string | null;
  additionalStreetInfo?: string | null;
  /** Whether or not the address is a company address.  */
  isCompany?: boolean;
  company?: string | null;
  /** CVR or Tax number */
  cvr?: string | null;
  region?: string | null;
  /** address_CF_District */
  district?: string | null;
  email?: string | null;
  poBox?: string | null;
  phoneNumber?: string | null;
  additionalAddressInfo?: string | null;
}

export interface GetOrderDraftRequest {
  /** @format guid */
  orderDraftId?: string | null;
  orderNumber?: string | null;
}

export interface OrderNumberResponse {
  orderNumber: string;
  locale: string;
}

export interface OrderHistoryResponse {
  pageOffset?: number;
  pageCount?: number;
  locale?: string;
  /** If this value is true, there might be more orders to fetch. The value can only be used to indicate if there might be more orders, and therefore if a "load more" button should shown. */
  thereMightBeMoreOrders?: boolean;
  orders?: OrderHistoryItemResponse[];
}

/** An order and and all subsequent changes to the order (https://kb.ecco.com/display/GLOBCOM/Data+mapping) */
export interface OrderHistoryItemResponse {
  /** If true, then the order has been modified since the original order (i.e. returns or appeasements has been added) */
  isOrderWithChange?: boolean;
  /** Total sales tax */
  totalTax?: CommercetoolsMoneyResponse;
  /** Discounts and savings */
  totalDiscount?: CommercetoolsMoneyResponse;
  /** Subtotal */
  subTotal?: CommercetoolsMoneyResponse;
  shippingCost?: CommercetoolsMoneyResponse;
  /** For instance 'ECOM' */
  orderType?: string;
  /** For instance 'Complete' */
  orderStatus?: string;
  orderNumber?: string;
  orderEmail?: string | null;
  hasGiftWrapping?: boolean;
  /** @format date-time */
  orderDateUtc?: string | null;
  /**
   * This value will be valid when all order lines has a pickup date, as the entire order can be picked up
   * @format date-time
   */
  pickupDateUtc?: string | null;
  /** For instance 'CAD' */
  orderCurrency?: string;
  /** Order Total */
  netPrice?: CommercetoolsMoneyResponse;
  totalAppeasement?: CommercetoolsMoneyResponse;
  giftWrappingCost?: CommercetoolsMoneyResponse;
  /** Note that there can be promotion names on order line items */
  promotionName?: string | null;
  /** @format int32 */
  articleCount?: number;
  orderReturnLink?: string | null;
  /** Ordering lines */
  lines?: OrderHistoryLineResponse[];
  /** Billing address */
  billingAddress?: OrderHistoryAddressResponse | null;
  /** Shipping address */
  shippingAddress?: OrderHistoryAddressResponse | null;
  /** Address of the store where the order can be picked up. */
  storeAddress?: OrderHistoryAddressResponse | null;
}

export interface CommercetoolsMoneyResponse {
  /** ISO 4217 */
  currencyCode?: string;
  /**
   * Money amount translated into a integer where the last N digits represents the fraction.
   * @format int32
   */
  centAmount?: number;
  /**
   * Number of fraction digits in the CentAmount
   * @format int32
   */
  fractionDigits?: number;
}

export interface OrderHistoryLineResponse {
  /** SKU (Product Id / Variant). Should always be 13 digits */
  productId?: string;
  /** EAN */
  ean?: string | null;
  trackingUrl?: string | null;
  trackingNumber?: string | null;
  /** @format int32 */
  quantity?: number;
  /** For instance 'Captured' */
  paymentStatus?: string;
  /** For instance 'DE00135248000010' */
  orderLineId?: string;
  /** If set, this is the order id that can provide details about a change to the order */
  changeOrderNumber?: string | null;
  lineType?: string;
  isReturn?: boolean;
  itemTax?: CommercetoolsMoneyResponse;
  /** For instance 'Shipped' */
  itemStatus?: string;
  itemNetPrice?: CommercetoolsMoneyResponse;
  itemListPrice?: CommercetoolsMoneyResponse;
  /** The price to show in FE */
  itemGrossPrice?: CommercetoolsMoneyResponse;
  itemDiscount?: CommercetoolsMoneyResponse;
  /** If PromotionId is set, the code needs to be looked up in Contentful */
  promotionId?: string | null;
  /** If this value is set, this value must be shown to the user. */
  promotionName?: string | null;
  /** @format date-time */
  shippingDateUtc?: string | null;
  /** @format date-time */
  pickupDateUtc?: string | null;
}

export interface OrderHistoryAddressResponse {
  /** For instance 'H7T 1C8' */
  zipCode?: string;
  street1?: string;
  street2?: string;
  /** For instance: 'QC' */
  state?: string;
  name?: string;
  lastName?: string;
  firstName?: string;
  country?: string;
  city?: string;
}

/** Request data for the Order History endpoint */
export interface OrderHistoryRequest {
  /** If the email is set, OrderId is also required */
  email?: string | null;
  /** A specific order to search for */
  orderId?: string | null;
  /** Whether or not changes to the initial order should be merged into the order */
  includeChanges?: boolean;
  /** The number of orders to skip (the 'pageOffset' name is misleading, as 'offset' would be more correct */
  pageOffset?: number;
  pageSize?: number;
}

export interface PaymentMethodResponse {
  adyenClientKey?: string | null;
  /**
   * The value to pay. It will be with decimals, so it may be 19.95. Null when called without a cart.
   * @format decimal
   */
  paymentValue?: number | null;
  /** Currency code (ISO). Null when called without a cart. */
  paymentCurrency?: string | null;
  /**
   * The current version of the cart in Commercetools.
   * HEAP will check that the version of the cart is the same when the payment is submitted to avoid version conflicts.
   * If there is a version conflict the payment will be rejected and the client should restart payment to ensure that payment is done against the latest version of the cart.
   * @format int32
   */
  cartVersion?: number | null;
  /** JSON encoded string containing the payment methods that the customer can choose from. The content of this string is partly from the payment provider (for instance Adyen) and should be passed to the client as is. */
  paymentMethodsJson?: string | null;
}

export interface GetPaymentMethodOptionsRequest {
  /**
   * Id of the cart. The amount to pay is gathered from the cart.
   * When omitted, payment methods are fetched without cart context (e.g. payment icons on PDP, Express Payment button).
   */
  cartId?: string | null;
  /**
   * Unique identifier for the checkout session used by Adyen dynamic ordering.
   * Generated by the frontend and must remain stable for the entire checkout session.
   */
  shopperConversionId?: string | null;
  /** Additional settings that SeeHeap can set. Will be ignored in production */
  seeHeap?: PaymentSeeHeapRequest | null;
}

export interface PaymentSeeHeapRequest {
  skipCartValidation?: boolean;
  createNewOrderNumber?: boolean;
}

export interface GetAllPaymentMethodOptionsRequest {
  markets: string[];
  /** If true, HEAP will force reading settings from Payment API instead of potentially using cached information */
  forceFetch?: boolean;
}

export type PerformPaymentResponse = PaymentResponseBase & object;

export interface PaymentResponseBase {
  /** For instance 'Adyen' or 'NoPay' */
  paymentProviderType: string;
  /** If 'true' then the payment is complete. An order confirmation + order in D365 will be created shortly. A new cart MUST be created as the current cart has been Frozen */
  isPaymentComplete: boolean;
  /** Gets a value indicating whether a payment is pending and waiitng for webhook  */
  isPaymentPending: boolean;
  /** Gets a value indicating whether the result represents a payment failure. */
  isPaymentFailure: boolean;
  /** Indicate that the final payment will come later, but HEAP and FE must freeze the cart and show the order confirmation. */
  isFreezeCart: boolean;
  /** The id of the order draft as provided by Payment API (Heap). Heap uses it to track the order draft through the payment process. This will be needed for the call to ConfirmPayment if the payment is not complete. */
  orderDraftId?: string | null;
  /** The order number / reference that was assigned to the order */
  orderNumber?: string | null;
  /** Result code as provided by the payment provider */
  resultCode: string;
  /** Additional information. Upon failure this will contain information about the failure. Upon success this may contain additional information about the payment result, depending on the provider. */
  message?: string | null;
  /** Response as provided by the payment provider */
  responseJson?: string | null;
}

export type ProcessPaymentRequest = PaymentRequestBase & {
  paymentMethod: string;
  /** The Shopper's IP address. */
  shopperIP?: string | null;
  /**
   * Tags added to URLs to track the effectiveness of marketing campaigns.
   * These parameters help analytics tools like Google Analytics understand where traffic is coming from.
   */
  utm: UtmModel;
  /**
   * Set this parameter to the origin URL of the page that you are loading the 3D Secure Component from.
   * @maxLength 80
   */
  origin?: string;
  /**
   * Unique session identifier used by Kount, applicable only in markets where Kount is enabled.
   * This value should be generated by the frontend and remain consistent throughout the entire checkout session.
   * @maxLength 32
   */
  kountSessionId?: string | null;
  /** The URL to return to after the payment is completed. */
  returnUrl?: string;
  /** Consent records to be registered */
  consent?: OrderConsentRequest | null;
  /** The payment request to be submitted by frontEnd. It's the raw JSON encoded response from the payment provider. For NoPay, this should be null. */
  paymentRequestJson?: string | null;
  /** The user agent of the browser making the payment request. This can be used for analytics and debugging purposes. */
  browserUserAgent?: string | null;
  /**
   * Unique identifier for the checkout session used by Adyen dynamic ordering.
   * Generated by the frontend and must remain stable for the entire checkout session.
   */
  shopperConversionId?: string | null;
  /**
   * When true, the payment was initiated via express checkout (e.g. Apple Pay Express).
   * Optional; omitted or null is treated as false.
   */
  isExpress?: boolean | null;
  /** Additional settings that SeeHeap can set. Will be ignored in production */
  seeHeap?: PaymentSeeHeapRequest | null;
};

export interface UtmModel {
  campaign?: string | null;
}

export interface OrderConsentRequest {
  /** Reference to the contentful text that covers privacy policy. Note that if the legal text covers multiple consents, the id can be reused */
  privacyPolicyConsentContentfulId?: string;
  /** Reference to the contentful text that covers terms and conditions. Note that if the legal text covers multiple consents, the id can be reused */
  termsAndConditionConsentContentfulId?: string;
  /** Optional reference to the contentful text that covers newsletters. Note that if the legal text covers multiple consents, the id can be reused */
  newsletterConsentContentfulId?: string | null;
}

export interface PaymentRequestBase {
  /**
   * The type of payment provider to use for the payment. For instance "Adyen", "AmazonPay" or "NoPay"
   * @minLength 1
   */
  providerType: string;
  /**
   * The unique identifier for the cart in CT
   * @minLength 1
   */
  cartId: string;
}

export type ConfirmPaymentResponse = PaymentResponseBase & object;

export type ConfirmPaymentRequest = PaymentRequestBase & {
  /**
   * The id of the order draft as provided by Payment API (Heap). It's provided via the response from the 'Pay'
   * @minLength 1
   */
  orderDraftId: string;
  /**
   * The payment request to be submitted by frontEnd. It's the raw JSON encoded response from the payment provider.
   * This is needed when the payment confirmation is handled within the Adyen drop-in
   */
  paymentRequestJson?: string | null;
  /**
   * Object that contains the URL-decoded redirectResult. This is required when a user has been redirected to another website for payment completion.
   * Drop-in redirects the shopper to another website or app to complete the payment.
   */
  redirectResult?: string | null;
  /** Additional settings that SeeHeap can set. Will be ignored in production */
  seeHeap?: PaymentSeeHeapRequest | null;
};

export interface CompletePaymentResponse {
  isSuccess: boolean;
  /** @format guid */
  orderDraftId: string;
  errorCode?: UseCaseResultErrorCode | null;
  errorMessage?: string | null;
}

export interface CompletePaymentRequest {
  cartId: string;
  /** @format int32 */
  cartVersion: number;
  cartHashSnapshotVersion: string;
  cartHashSnapshot: string;
  /** @format guid */
  orderDraftId: string;
  /** @format guid */
  heapSessionId?: string;
}

export interface ProductsAvailabilityRequest {
  skus: string[];
  cartId: string;
}

export interface CreateSessionResponse {
  /** The session id which is needed for all calls to HEAP. */
  heapSessionId: string;
  /**
   * Validity period for the Heap Session
   * @format int32
   */
  expiresInSeconds?: number;
  /** This object may contain the Commercetools anonymous token. */
  token?: SessionTokenResponse | null;
}

export interface ParcelShop {
  storeId?: string;
  name?: string;
  parcelTypeCode?: string;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  carrier?: string;
  street1?: string;
  postalCode?: string;
  city?: string;
  countryCode?: string;
  walkInHours?: WalkInHours | null;
}

export interface WalkInHours {
  mon?: WalkInTime | null;
  tue?: WalkInTime | null;
  wed?: WalkInTime | null;
  thu?: WalkInTime | null;
  fri?: WalkInTime | null;
  sat?: WalkInTime | null;
  sun?: WalkInTime | null;
}

export interface WalkInTime {
  open?: string | null;
  close?: string | null;
}

export interface CarrierCapabilityDto {
  carrier?: SupportedCarriers;
  countryCode?: string;
  postalCode?: string;
  city?: string | null;
  /** @format date-time */
  lastUpdate?: string;
  capabilities?: CapabilitiesDto;
}

export interface CapabilitiesDto {
  homeDeliveryAvailable?: boolean;
}

export interface WishlistResponse {
  wishlists?: WishlistDto[];
}

export interface WishlistDto {
  id?: string;
  customer?: WishlistCustomerDto;
  storeId?: string;
  anonymousId?: string | null;
  /** @format int32 */
  version?: number;
  name?: string | null;
  /** @format date-time */
  createdAt?: string;
  lineItems?: WishlistLineItemDto[];
}

export interface WishlistCustomerDto {
  id?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
}

export interface WishlistLineItemDto {
  id?: string;
  productId?: string;
  name?: string;
  isMasterVariant?: boolean;
  variant?: WishlistVariantDto | null;
  /** @format date-time */
  addedAt?: string;
  /** @format int32 */
  quantity?: number;
}

export interface WishlistVariantDto {
  sku?: string;
  images?: WishlistImageDto[];
  articleNumber?: string | null;
  colorCode?: string | null;
  size?: string | null;
  sizeCN?: string | null;
  sizeUS?: string | null;
  materialGroup?: string | null;
  sizeUK?: string | null;
  sizeKR?: string | null;
  sizeJP?: string | null;
  sizeCA?: string | null;
  dominantColor?: Record<string, string> | null;
  backgroundColor?: string | null;
  descriptiveHeading?: Record<string, string> | null;
  division?: Record<string, string> | null;
  collectionType?: Record<string, string> | null;
  collectionClass?: Record<string, string> | null;
  pageTitle?: Record<string, string> | null;
}

export interface WishlistImageDto {
  label?: string;
  url?: string;
}

/** Request to add a product item to a wishlist. */
export interface AddWishlistItemRequest {
  /**
   * The current version of the wishlist for optimistic concurrency control.
   * @format int64
   */
  version: number;
  /** The SKU (Stock Keeping Unit) that uniquely identifies the product variant. */
  sku?: string;
  /**
   * The quantity of the product to add to the wishlist.
   * @format int32
   */
  quantity?: number;
}

/** Request model for changing the quantity of an item in a wishlist. */
export interface ChangeWishlistItemQuantityRequest {
  /**
   * The current version of the wishlist for optimistic concurrency control.
   * @format int64
   */
  version?: number;
  /**
   * The new quantity of the product in the wishlist.
   * @format int32
   */
  quantity?: number;
}

/** Request for removing an item from a wishlist */
export interface RemoveWishlistItemRequest {
  /**
   * The current version of the wishlist for optimistic concurrency control
   * @format int64
   */
  version: number;
}

export interface ChangeProductSizeRequest {
  /**
   * The version of the wishlist to update
   * @format int64
   */
  version?: number;
  /**
   * The new SKU for the product size
   * @minLength 1
   */
  newSku: string;
}

export interface WishlistProductResponse {
  products?: WishlistProductDto[];
}

export interface WishlistProductDto {
  id?: string;
  variants?: WishlistProductVariantDto[];
}

export interface WishlistProductVariantDto {
  sku?: string;
  size?: string | null;
  sizeCN?: string | null;
  sizeUS?: string | null;
  sizeUK?: string | null;
  sizeKR?: string | null;
  sizeJP?: string | null;
  sizeCA?: string | null;
  color?: Record<string, string> | null;
  materialGroupLocalized?: Record<string, string> | null;
  inventory?: InventoryLocationDto[];
}

export interface InventoryLocationDto {
  locationId?: string;
  locationName?: string | null;
  isInStock?: boolean;
  /** @format int32 */
  availableQuantity?: number | null;
}

export interface GetProductsAvailabilityRequest {
  skus?: string[];
  inventoryLocationIds?: string[];
}

export interface DiscountCodeUsageRequest {
  discountCodeId: string;
  increaseUsage: boolean;
}

export type SocialLoginUseCaseResult = BaseUseCaseResult & {
  socialIdentities?: SocialIndentityModel[] | null;
};

export interface SocialIndentityModel {
  socialProvider: SocialProvider;
  socialProviderAccountId: string;
  countryCode: string;
  crmEmail: string;
  socialEmail: string;
  shadowPassword?: string | null;
  statistics?: SocialStatisticsModel | null;
}

export interface SocialStatisticsModel {
  socialProvider?: SocialProvider;
  socialProviderAccountId?: string;
  countryCode?: string;
  socialEmail?: string;
  /** @format date-time */
  firstLoginAt: string;
  /** @format date-time */
  lastLoginAt: string;
  /** @format int32 */
  numberLogins: number;
}

export interface DeleteSocialLoginDataRequest {
  email: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string =
    "https://ca-heapapi-test-westeurope.test.ecom.ecco.com";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title HEAP
 * @version 1.6.84
 * @baseUrl https://ca-heapapi-test-westeurope.test.ecom.ecco.com
 *
 * by Headless @ ECCO
 *
 * Controllers starting with 'Test' are work-in-progress and is mostly for backend purposes. Endpoints starting with 'QA' can be used for testing purposes to manipulate data. The 'ServiceAPI' endpoints is temporary and will be replaced by a stand-alone REST API site at some point
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Returns 204 No Content when subscription is successful but no customer data is returned (SFAPI behavior) Returns 200 OK with customer data when available
     *
     * @tags Anonymous
     * @name AnonymousNewsletterOptIn
     * @summary Subscribes an anonymous user to the newsletter
     * @request POST:/api/v1/Anonymous/Newsletter/OptIn
     * @secure
     */
    anonymousNewsletterOptIn: (
      data: NewsLetterOptInRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomerResponse, EndpointFailureResponse>({
        path: `/api/v1/Anonymous/Newsletter/OptIn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Anonymous
     * @name AnonymousNewsletterOptOut
     * @summary Log out of a newsletter. As only the email is used, this opt-out may have "side-effects"
     * @request POST:/api/v1/Anonymous/Newsletter/OptOut
     * @secure
     */
    anonymousNewsletterOptOut: (
      query?: {
        email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerResponse, EndpointFailureResponse>({
        path: `/api/v1/Anonymous/Newsletter/OptOut`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackInStock
     * @name BackInStockGetSubscriptions
     * @summary Gets back-in-stock subscriptions
     * @request GET:/api/v1/BackInStock/Subscriptions
     * @secure
     */
    backInStockGetSubscriptions: (
      query?: {
        guestEmail?: string | null;
        status?: Status | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<Subscription[], ErrorResponse | void>({
        path: `/api/v1/BackInStock/Subscriptions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackInStock
     * @name BackInStockSubscribeItem
     * @summary Creates a back-in-stock subscription
     * @request POST:/api/v1/BackInStock/Subscriptions/Add
     * @secure
     */
    backInStockSubscribeItem: (
      data: AddSubscriptionRequest,
      params: RequestParams = {},
    ) =>
      this.request<number, ErrorResponse | void>({
        path: `/api/v1/BackInStock/Subscriptions/Add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackInStock
     * @name BackInStockUnsubscribeAll
     * @summary Cancel all back-in-stock subscriptions
     * @request DELETE:/api/v1/BackInStock/Subscriptions/CancelAll
     * @secure
     */
    backInStockUnsubscribeAll: (
      query?: {
        guestEmail?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<number[], ErrorResponse | void>({
        path: `/api/v1/BackInStock/Subscriptions/CancelAll`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackInStock
     * @name BackInStockUnsubscribeItem
     * @summary Cancel a back-in-stock subscription
     * @request DELETE:/api/v1/BackInStock/Subscriptions/Cancel
     * @secure
     */
    backInStockUnsubscribeItem: (
      query?: {
        /** @format int32 */
        subscriptionId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<number, ErrorResponse | void>({
        path: `/api/v1/BackInStock/Subscriptions/Cancel`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackInStockSubscriptions
     * @name BackInStockSubscriptionsCreateSubscription
     * @summary Deprecated: use api/v1/BackInStock/Subscribe instead. Creates a back-in-stock subscription for a product SKU. Requires UCID for logged-in users or GuestEmail for guests.
     * @request POST:/api/v1/BackInStockSubscriptions
     * @secure
     */
    backInStockSubscriptionsCreateSubscription: (
      data: CreateSubscriptionRequest,
      params: RequestParams = {},
    ) =>
      this.request<number, ErrorResponse | void>({
        path: `/api/v1/BackInStockSubscriptions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cart
     * @name CartCartValidation
     * @request GET:/api/v1/Cart/Validate/{cartId}/{source}
     * @secure
     */
    cartCartValidation: (
      cartId: string,
      source: string,
      params: RequestParams = {},
    ) =>
      this.request<ValidateCartResponse, ProblemDetails | void>({
        path: `/api/v1/Cart/Validate/${cartId}/${source}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cart
     * @name CartRebuildCartFromLink
     * @request POST:/api/v1/Cart/RebuildCartFromLink
     * @secure
     */
    cartRebuildCartFromLink: (
      data: RebuildCartRequest,
      params: RequestParams = {},
    ) =>
      this.request<RebuildCartResponse, ErrorResponse>({
        path: `/api/v1/Cart/RebuildCartFromLink`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContactForm
     * @name ContactFormSendContactForm
     * @summary Send a message to Customer Service
     * @request POST:/api/v1/ContactForm/Send
     * @secure
     */
    contactFormSendContactForm: (
      data: CustomerContactFormRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, EndpointFailureResponse>({
        path: `/api/v1/ContactForm/Send`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerLogin
     * @summary Sign in to Headless
     * @request POST:/api/v1/Customer/Authenticate/Login
     * @secure
     */
    customerLogin: (data: CustomerLoginRequest, params: RequestParams = {}) =>
      this.request<CustomerLoginResponse, EndpointFailureResponse>({
        path: `/api/v1/Customer/Authenticate/Login`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerSocialLogin
     * @summary Sign in to Headless using social login
     * @request POST:/api/v1/Customer/Authenticate/SocialLogin
     * @secure
     */
    customerSocialLogin: (
      data: CustomerSocialLoginRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomerLoginResponse, EndpointFailureResponse>({
        path: `/api/v1/Customer/Authenticate/SocialLogin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerLogout
     * @request POST:/api/v1/Customer/Authenticate/Logout
     * @secure
     */
    customerLogout: (params: RequestParams = {}) =>
      this.request<CustomerLogoutResponse, EndpointFailureResponse>({
        path: `/api/v1/Customer/Authenticate/Logout`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerGet
     * @summary Get the customers profile (it will only be returned if "Terms and Conditions" consent are valid)
     * @request GET:/api/v1/Customer/Profile
     * @secure
     */
    customerGet: (params: RequestParams = {}) =>
      this.request<CustomerResponse, EndpointFailureResponse>({
        path: `/api/v1/Customer/Profile`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerCreate
     * @summary Create a new customer. One can only create a new customer if the UCID header value is not set. Note that both Privacy Policy and Terms and Conditions must be accepted. This endpoint supports both creation of Loyalty members + non-loyalty members
     * @request POST:/api/v1/Customer/Profile/Create
     * @secure
     */
    customerCreate: (data: CreateCustomerRequest, params: RequestParams = {}) =>
      this.request<CustomerResponse, EndpointFailureResponse>({
        path: `/api/v1/Customer/Profile/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerUpdate
     * @summary Update basic customer data
     * @request POST:/api/v1/Customer/Profile/Update
     * @secure
     */
    customerUpdate: (data: UpdateCustomerRequest, params: RequestParams = {}) =>
      this.request<CustomerResponse, EndpointFailureResponse>({
        path: `/api/v1/Customer/Profile/Update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerDelete
     * @summary Delete customer profile. The profile will be instantly deactivated
     * @request DELETE:/api/v1/Customer/Profile/Delete
     * @secure
     */
    customerDelete: (
      query?: {
        /**
         * If true, then HEAP will only delete the account within Headless. This should only be set to true in case deletion in other systems are handled by the caller.
         * If false, then the account will be deleted within Headless and Customer Hub will also be triggered to ensure an account deletion in all systems
         */
        InternalDeletionOnly?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, EndpointFailureResponse>({
        path: `/api/v1/Customer/Profile/Delete`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerAddAddress
     * @summary Add an address. Several addresses can be added also with the same type
     * @request POST:/api/v1/Customer/Address/Add
     * @secure
     */
    customerAddAddress: (
      data: CustomerAddressRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomerResponse, EndpointFailureResponse>({
        path: `/api/v1/Customer/Address/Add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerEditAddress
     * @summary Edit an existing address object
     * @request POST:/api/v1/Customer/Address/Edit
     * @secure
     */
    customerEditAddress: (
      data: CustomerEditAddressRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomerResponse, EndpointFailureResponse>({
        path: `/api/v1/Customer/Address/Edit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerDeleteAddress
     * @summary Delete a single address object
     * @request DELETE:/api/v1/Customer/Address/Delete
     * @secure
     */
    customerDeleteAddress: (
      query?: {
        addressId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerResponse, EndpointFailureResponse>({
        path: `/api/v1/Customer/Address/Delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerConsentOptIn
     * @summary Opt-in (agree) to a certain consent. Note that Newsletter consent should be given though the 'NewsletterOptIn' endpoint as additional actions will be performed upon newsletter opt-in.
     * @request POST:/api/v1/Customer/Consent/OptIn
     * @secure
     */
    customerConsentOptIn: (
      data: ConsentOptInRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomerResponse, EndpointFailureResponse>({
        path: `/api/v1/Customer/Consent/OptIn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerConsentOptOut
     * @summary Remove a certain consent. Note that if TermsAndConditions or PrivacyPolicy is revoked, no other consents are valid. Use 'NewsletterOptOut' for opting out of a newsletter consent
     * @request POST:/api/v1/Customer/Consent/OptOut
     * @secure
     */
    customerConsentOptOut: (
      query?: {
        /**
         * Newsletter = 0, MyECCO = 1, TermsAndConditions = 2, PrivacyPolicy = 3, Loyalty = 4, Personalisation = 5,
         * @format int32
         */
        consentType?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerResponse, EndpointFailureResponse>({
        path: `/api/v1/Customer/Consent/OptOut`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerNewsletterOptIn
     * @summary The 'contentfulId' id for the Newsletter consent, and 'privacyContentfulId' is for the Privacy Policy
     * @request POST:/api/v1/Customer/Newsletter/OptIn
     * @secure
     */
    customerNewsletterOptIn: (
      data: NewsLetterOptInRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomerResponse, EndpointFailureResponse>({
        path: `/api/v1/Customer/Newsletter/OptIn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerNewsletterOptOut
     * @summary Remove newsletter subscription
     * @request POST:/api/v1/Customer/Newsletter/OptOut
     * @secure
     */
    customerNewsletterOptOut: (params: RequestParams = {}) =>
      this.request<CustomerResponse, EndpointFailureResponse>({
        path: `/api/v1/Customer/Newsletter/OptOut`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerChangePassword
     * @summary Change the password. The complexity of the password will be validated against market-specific settings. See Heap/PasswordRequirements for the actual requirements After a change password you need to create a new session and login again (as this is required by Commercetools)
     * @request PUT:/api/v1/Customer/Password/Change
     * @secure
     */
    customerChangePassword: (
      data: ChangePasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, EndpointFailureResponse>({
        path: `/api/v1/Customer/Password/Change`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerInitiatePasswordChange
     * @summary Initiate the 'reset password' session. Upon success a mail is sent to the customer with a link to the password reset Uri.
     * @request POST:/api/v1/Customer/Password/InitiatePasswordChange
     * @secure
     */
    customerInitiatePasswordChange: (
      data: InitiatePasswordChangeRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomerInitiatePasswordResponse, EndpointFailureResponse>({
        path: `/api/v1/Customer/Password/InitiatePasswordChange`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomerCompletePasswordChange
     * @summary Completes a password reset session. If the new password is ok then the password will be set and the password reset token will no longer be useful.
     * @request POST:/api/v1/Customer/Password/CompletePasswordChange
     * @secure
     */
    customerCompletePasswordChange: (
      data: CompletePasswordChangeRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, EndpointFailureResponse>({
        path: `/api/v1/Customer/Password/CompletePasswordChange`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Delivery
     * @name DeliveryGetDeliveryDates
     * @summary Gets the available delivery dates for designated delivery. This endpoint supports only the Japan (JP) market.
     * @request GET:/api/v1/Delivery/Dates
     * @secure
     */
    deliveryGetDeliveryDates: (
      query?: {
        Prefecture?: string;
        CartId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDeliveryDatesResponse, ProblemDetails | void>({
        path: `/api/v1/Delivery/Dates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryEstimate
     * @name DeliveryEstimateGetDeliveryEstimate
     * @request GET:/api/v1/delivery-estimate
     * @secure
     */
    deliveryEstimateGetDeliveryEstimate: (
      query?: {
        Skus?: string;
        Country?: string;
        Zipcode?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeliveryEstimateResponse[], ProblemDetails | void>({
        path: `/api/v1/delivery-estimate`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthPing
     * @summary Checks the health status of the application.
     * @request GET:/api/v1/Health
     */
    healthPing: (params: RequestParams = {}) =>
      this.request<GetPingResponse, any>({
        path: `/api/v1/Health`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthHealthPaymentApi
     * @summary Checks the health status of the Payment API application
     * @request GET:/api/v1/Health/PaymentApi
     */
    healthHealthPaymentApi: (params: RequestParams = {}) =>
      this.request<GetPingResponse, any>({
        path: `/api/v1/Health/PaymentApi`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthTimeOutTest
     * @summary Executes a 2 minute delay. Can be used to test if any firewalls etc will time out before Heap does
     * @request POST:/api/v1/Health/TimeOutTest
     */
    healthTimeOutTest: (params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/v1/Health/TimeOutTest`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Heap
     * @name HeapGetErrorCodes
     * @summary Get the full list of error codes that can be returned by HEAP
     * @request GET:/api/v1/Heap/ErrorCodes
     * @secure
     */
    heapGetErrorCodes: (params: RequestParams = {}) =>
      this.request<ErrorCodeResponse[], any>({
        path: `/api/v1/Heap/ErrorCodes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Heap
     * @name HeapGetMarketConfiguration
     * @summary Get configurations for a specific market. The frontend can potentially use this information to ensure that (some) configurations in sync.
     * @request GET:/api/v1/Heap/MarketConfiguration
     * @secure
     */
    heapGetMarketConfiguration: (params: RequestParams = {}) =>
      this.request<MarketSettingsResponse[], any>({
        path: `/api/v1/Heap/MarketConfiguration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Heap
     * @name HeapGetStorageConfiguration
     * @summary Get configurations for a specific market. The frontend can potentially use this information to ensure that (some) configurations in sync.
     * @request GET:/api/v1/Heap/StorageConfiguration
     * @secure
     */
    heapGetStorageConfiguration: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Heap/StorageConfiguration`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags InStoreSignUp
     * @name InStoreSignUpStart
     * @request POST:/api/v1/InStoreSignUp/Initiate
     * @secure
     */
    inStoreSignUpStart: (
      data: InitiateSignUpRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, EndpointFailureResponse | void>({
        path: `/api/v1/InStoreSignUp/Initiate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags InStoreSignUp
     * @name InStoreSignUpComplete
     * @request POST:/api/v1/InStoreSignUp/Finalize
     * @secure
     */
    inStoreSignUpComplete: (
      data: FinalizeSignUpRequest,
      params: RequestParams = {},
    ) =>
      this.request<FinalizeSignUpResponse, EndpointFailureResponse | void>({
        path: `/api/v1/InStoreSignUp/Finalize`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Legacy
     * @name LegacyCreateCart
     * @summary Create and return a new commercetools cart (Equivalent to the cart/me/create endpoint in SFAPI)
     * @request POST:/api/v1/Legacy/CreateCart
     * @secure
     */
    legacyCreateCart: (data: CreateCartRequest, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/v1/Legacy/CreateCart`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Legacy
     * @name LegacyValidateShipping
     * @summary Validate that the current cart (order) can be shipped to the address in the cart. It will depend on the address and shippingmethod (Equivalent to the shipping/ValidateShipping/me in SFAPI)
     * @request POST:/api/v1/Legacy/ValidateShipping
     * @secure
     */
    legacyValidateShipping: (
      query?: {
        /** Optional id of the cart that needs to be tested. When provided, that cart is validated without a Heap session. When omitted, the current 'my' cart is validated and a Heap session is required. */
        cartId?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShippingValidatorResult, any>({
        path: `/api/v1/Legacy/ValidateShipping`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Legacy
     * @name LegacyShippingPrices
     * @summary Get estimated shipping prices for the cart identified by cartId. When cartId is omitted, the current active 'my' cart is used (Equivalent to the Shipping/Prices/me in SFAPI)
     * @request GET:/api/v1/Legacy/ShippingPrices
     * @secure
     */
    legacyShippingPrices: (
      query?: {
        /**
         * Optional. Accepted for compatibility and ignored. Shipping fees are always included.
         * @default true
         */
        withFees?: boolean;
        /**
         * Optional. Accepted for compatibility and ignored. Every shipping method is always returned.
         * @default true
         */
        getAll?: boolean;
        /** Optional id of the cart. When provided, that cart is priced without a Heap session. When omitted, the current 'my' cart is used and a Heap session with a Commercetools token is required. */
        cartId?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ProblemDetails>({
        path: `/api/v1/Legacy/ShippingPrices`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags LoyaltyHistory
     * @name LoyaltyHistoryGetLoyaltyHistory
     * @summary Retrieves loyalty transactions for the logged-in user. By default, it fetches the last 10 transactions from the last 24 months. UCID and HeapSessionId are required headers.
     * @request GET:/api/v1/LoyaltyHistory
     * @secure
     */
    loyaltyHistoryGetLoyaltyHistory: (params: RequestParams = {}) =>
      this.request<GetLoyaltyHistoryResponse, ErrorResponse | void>({
        path: `/api/v1/LoyaltyHistory`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Order
     * @name OrderGetOrderStatus
     * @summary Retrieves the current status of an order draft based on the specified request. Use "OrderDraftId" for requests.
     * @request POST:/api/v1/Order/Order/Status
     * @secure
     */
    orderGetOrderStatus: (
      data: GetOrderDraftRequest,
      params: RequestParams = {},
    ) =>
      this.request<OrderDraftResponse, ProblemDetails | void>({
        path: `/api/v1/Order/Order/Status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Order
     * @name OrderCreateOrderNumber
     * @summary Create a new unique order number / order reference. It should be added to the cart in Commercetools.
     * @request POST:/api/v1/Order/Order/CreateOrderNumber
     * @secure
     */
    orderCreateOrderNumber: (params: RequestParams = {}) =>
      this.request<OrderNumberResponse, ProblemDetails | void>({
        path: `/api/v1/Order/Order/CreateOrderNumber`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderHistory
     * @name OrderHistoryGetOrderHistory
     * @request POST:/api/v1/OrderHistory
     * @secure
     */
    orderHistoryGetOrderHistory: (
      data: OrderHistoryRequest,
      params: RequestParams = {},
    ) =>
      this.request<OrderHistoryResponse, ProblemDetails | void>({
        path: `/api/v1/OrderHistory`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentGetPaymentMethodOptions
     * @summary If the cart can be validated this method will create a list of payment methods that the customer can choose from
     * @request POST:/api/v1/Payment/GetPaymentMethodOptions
     * @secure
     */
    paymentGetPaymentMethodOptions: (
      data: GetPaymentMethodOptionsRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentMethodResponse, EndpointFailureResponse>({
        path: `/api/v1/Payment/GetPaymentMethodOptions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentGetAllPaymentMethods
     * @summary Get the list of all payment methods for all markets
     * @request POST:/api/v1/Payment/GetAllPaymentMethods
     * @secure
     */
    paymentGetAllPaymentMethods: (
      data: GetAllPaymentMethodOptionsRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentMethodResponse, EndpointFailureResponse>({
        path: `/api/v1/Payment/GetAllPaymentMethods`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentProcessPayment
     * @summary Submit payment. Some payments will complete fully. Others will require an additional validation in which case a call to ConfirmPayment will be needed to finalize the payment. The order draft will also be created here.
     * @request POST:/api/v1/Payment/Pay
     * @secure
     */
    paymentProcessPayment: (
      data: ProcessPaymentRequest,
      params: RequestParams = {},
    ) =>
      this.request<PerformPaymentResponse, EndpointFailureResponse>({
        path: `/api/v1/Payment/Pay`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentConfirmPayment
     * @summary Submit additional payment details to complete the payment for payments where additional confirmation is needed. This step is only needed when no final state has been reached on the /initiate request, for example when the shopper was redirected to another page to complete the payment
     * @request POST:/api/v1/Payment/ConfirmPayment
     * @secure
     */
    paymentConfirmPayment: (
      data: ConfirmPaymentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ConfirmPaymentResponse, EndpointFailureResponse>({
        path: `/api/v1/Payment/ConfirmPayment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentCompletePayment
     * @summary Performs post-payment actions, such as freeze cart and handle discount code usage. Called by Payment API when Hook authorizes a payment.
     * @request POST:/api/v1/Payment/CompletePayment
     * @secure
     */
    paymentCompletePayment: (
      data: CompletePaymentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CompletePaymentResponse, EndpointFailureResponse>({
        path: `/api/v1/Payment/CompletePayment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product
     * @name ProductProductsAvailability
     * @request POST:/api/v1/Product/ProductsAvailability
     * @secure
     */
    productProductsAvailability: (
      data: ProductsAvailabilityRequest,
      params: RequestParams = {},
    ) =>
      this.request<string, ProblemDetails | void>({
        path: `/api/v1/Product/ProductsAvailability`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceApi
     * @name ServiceApiGenerateBarcode
     * @request GET:/api/v1/ServiceApi/Generate/{height}/{width}/{margin}/{barcodeString}.png
     * @secure
     */
    serviceApiGenerateBarcode: (
      height: number,
      width: number,
      margin: number,
      barcodeString: string,
      params: RequestParams = {},
    ) =>
      this.request<Blob, any>({
        path: `/api/v1/ServiceApi/Generate/${height}/${width}/${margin}/${barcodeString}.png`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Session
     * @name SessionCreateSession
     * @summary Create a new HEAP session
     * @request GET:/api/v1/Session/Create
     * @secure
     */
    sessionCreateSession: (
      query?: {
        /**
         * Optional ga_session_id that is assigned to the session. This is useful for advanced analytics as it allows for the combination of a customer with the session
         * @format int32
         */
        googleAnalyticsSessionId?: number | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<CreateSessionResponse, EndpointFailureResponse>({
        path: `/api/v1/Session/Create`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Session
     * @name SessionRefreshCommercetoolsToken
     * @summary Refreshes the current commercetools token
     * @request GET:/api/v1/Session/RefreshCommercetoolsToken
     * @secure
     */
    sessionRefreshCommercetoolsToken: (params: RequestParams = {}) =>
      this.request<CreateSessionResponse, EndpointFailureResponse>({
        path: `/api/v1/Session/RefreshCommercetoolsToken`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Session
     * @name SessionAssignGoogleAnalyticsSessionId
     * @summary Assign a google analytics id (ga_session_id) to a HEAP session.
     * @request PUT:/api/v1/Session/AssignGoogleAnalyticsSessionId
     * @secure
     */
    sessionAssignGoogleAnalyticsSessionId: (
      query?: {
        /**
         * ga_session_id that is assigned to the session. This is useful for advanced analytics as it allows for the combination of a customer with the session
         * @format int32
         */
        googleAnalyticsSessionId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, EndpointFailureResponse>({
        path: `/api/v1/Session/AssignGoogleAnalyticsSessionId`,
        method: "PUT",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipping
     * @name ShippingSearchParcelShops
     * @request GET:/api/v1/Shipping/ParcelShops/Search
     * @secure
     */
    shippingSearchParcelShops: (
      query?: {
        City?: string | null;
        PostCode?: string | null;
        /** @format double */
        Latitude?: number | null;
        /** @format double */
        Longitude?: number | null;
        /** @format int32 */
        RadiusInMeters?: number | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ParcelShop[], ProblemDetails | void>({
        path: `/api/v1/Shipping/ParcelShops/Search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipping
     * @name ShippingGetCarrierCapabilities
     * @request GET:/api/v1/Shipping/Carriers/{carrier}/{postalCode}
     * @secure
     */
    shippingGetCarrierCapabilities: (
      carrier: SupportedCarriers,
      postalCode: string,
      params: RequestParams = {},
    ) =>
      this.request<CarrierCapabilityDto, ProblemDetails | void>({
        path: `/api/v1/Shipping/Carriers/${carrier}/${postalCode}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wishlist
     * @name WishlistGetMyActiveWishlist
     * @summary Gets the wishlist for the authenticated user.
     * @request GET:/api/v1/Wishlist
     * @secure
     */
    wishlistGetMyActiveWishlist: (params: RequestParams = {}) =>
      this.request<WishlistResponse, EndpointFailureResponse | ProblemDetails>({
        path: `/api/v1/Wishlist`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wishlist
     * @name WishlistCreateWishlist
     * @summary Creates a new wishlist for the authenticated user.
     * @request POST:/api/v1/Wishlist
     * @secure
     */
    wishlistCreateWishlist: (params: RequestParams = {}) =>
      this.request<WishlistDto, EndpointFailureResponse>({
        path: `/api/v1/Wishlist`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wishlist
     * @name WishlistDeleteWishlist
     * @summary Deletes a wishlist by its ID.
     * @request DELETE:/api/v1/Wishlist/{wishlistId}
     * @secure
     */
    wishlistDeleteWishlist: (wishlistId: string, params: RequestParams = {}) =>
      this.request<void, EndpointFailureResponse>({
        path: `/api/v1/Wishlist/${wishlistId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wishlist
     * @name WishlistAddProductToWishlist
     * @summary Adds a product to a wishlist.
     * @request POST:/api/v1/Wishlist/{wishlistId}/items
     * @secure
     */
    wishlistAddProductToWishlist: (
      wishlistId: string,
      data: AddWishlistItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<WishlistResponse, EndpointFailureResponse>({
        path: `/api/v1/Wishlist/${wishlistId}/items`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wishlist
     * @name WishlistChangeProductQuantityInWishlist
     * @summary Changes the quantity of a product in a wishlist.
     * @request PUT:/api/v1/Wishlist/{wishlistId}/items/{lineItemId}
     * @secure
     */
    wishlistChangeProductQuantityInWishlist: (
      wishlistId: string,
      lineItemId: string,
      data: ChangeWishlistItemQuantityRequest,
      params: RequestParams = {},
    ) =>
      this.request<WishlistResponse, EndpointFailureResponse>({
        path: `/api/v1/Wishlist/${wishlistId}/items/${lineItemId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wishlist
     * @name WishlistRemoveProductFromWishlist
     * @summary Removes a product from a wishlist.
     * @request DELETE:/api/v1/Wishlist/{wishlistId}/items/{lineItemId}
     * @secure
     */
    wishlistRemoveProductFromWishlist: (
      wishlistId: string,
      lineItemId: string,
      data: RemoveWishlistItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<WishlistResponse, EndpointFailureResponse>({
        path: `/api/v1/Wishlist/${wishlistId}/items/${lineItemId}`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wishlist
     * @name WishlistChangeProductSizeInWishlist
     * @summary Changes the size-sku of a product in a wishlist.
     * @request PUT:/api/v1/Wishlist/{wishlistId}/items/{lineItemId}/size
     * @secure
     */
    wishlistChangeProductSizeInWishlist: (
      wishlistId: string,
      lineItemId: string,
      data: ChangeProductSizeRequest,
      params: RequestParams = {},
    ) =>
      this.request<WishlistResponse, EndpointFailureResponse>({
        path: `/api/v1/Wishlist/${wishlistId}/items/${lineItemId}/size`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wishlist
     * @name WishlistGetProductsAvailability
     * @summary Gets product information and stock availability by SKUs.
     * @request POST:/api/v1/Wishlist/products/availability
     * @secure
     */
    wishlistGetProductsAvailability: (
      data: GetProductsAvailabilityRequest,
      params: RequestParams = {},
    ) =>
      this.request<WishlistProductResponse, EndpointFailureResponse>({
        path: `/api/v1/Wishlist/products/availability`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TestCart
     * @name TestCartDiscountUsage
     * @request POST:/api/v1/TestCart/AdjustDiscountCodeUsage
     * @secure
     */
    testCartDiscountUsage: (
      data: DiscountCodeUsageRequest,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TestCart/AdjustDiscountCodeUsage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TestSocialLogin
     * @name TestSocialLoginGetSocialLoginData
     * @request POST:/api/v1/TestSocialLogin/GetSocialLoginData
     * @secure
     */
    testSocialLoginGetSocialLoginData: (
      data: DeleteSocialLoginDataRequest,
      params: RequestParams = {},
    ) =>
      this.request<SocialLoginUseCaseResult, any>({
        path: `/api/v1/TestSocialLogin/GetSocialLoginData`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TestSocialLogin
     * @name TestSocialLoginDeleteSocialLoginData
     * @request POST:/api/v1/TestSocialLogin/DeleteSocialLoginData
     * @secure
     */
    testSocialLoginDeleteSocialLoginData: (
      data: DeleteSocialLoginDataRequest,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TestSocialLogin/DeleteSocialLoginData`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
